<nz-form-item *ngIf="config">
  <nz-form-label [nzSpan]="6">距左边边距</nz-form-label>
  <nz-form-control>
    <input nz-input #nameInput="ngModel" name="paddingLeft" type="text" [(ngModel)]="config.paddingLeft" />
  </nz-form-control>
</nz-form-item>

<nz-form-item *ngIf="config">
  <nz-form-label [nzSpan]="6">字体颜色</nz-form-label>
  <nz-form-control>
    <!-- <color-sketch [color]="config.color" (onChangeComplete)="changeComplete($event)"></color-sketch> -->
    <input nz-input #nameInput="ngModel" name="value" type="text" [(ngModel)]="config.color" />
  </nz-form-control>
</nz-form-item>

<nz-form-item *ngIf="config">
  <nz-form-label [nzSpan]="6">字体大小</nz-form-label>
  <nz-form-control>
    <input nz-input #nameInput="ngModel" name="value" type="text" [(ngModel)]="config.fontSize" />
  </nz-form-control>
</nz-form-item>
<nz-form-item *ngIf="config">
  <nz-form-label [nzSpan]="6">粗体</nz-form-label>
  <nz-form-control>
    <input nz-input #nameInput="ngModel" name="value" type="text" [(ngModel)]="config.weight" />
  </nz-form-control>
</nz-form-item>
